import styled from 'styled-components';

const EditButtons = styled.div`
  margin-left: 5px;
`;

export default EditButtons;
